const state = {
  services: [
    {
      id: 1,
      name: '电力交易全托管',
      shortDesc: '360度无忧交易托管，对电价/收益负责',
      icon: 'fas fa-bolt',
      description: '基于PowerMind大模型，提供电量预测、价格预测、策略推荐、申报盯盘与交易复盘的全流程托管服务，减少集团整体交易运营成本，实现最优交易结果。',
      features: ['电量/价格多模型预测', '策略推荐与确认', '全流程申报盯盘', '多维度交易复盘'],
      process: ['数据获取', '电量与价格预测', '策略推荐与确认', '申报盯盘', '交易复盘'],
      image: require('@/assets/5.png')
    },
    {
      id: 2,
      name: '设备智能运维',
      shortDesc: '多模态诊断，故障提前预警',
      icon: 'fas fa-gauge-high',
      description: '以MtMind/PowerMind为底座，融合图像、振动、电流等多模态数据进行设备智能诊断，覆盖风电、热电等装备，实现从定期巡检到按需点检的模式升级。',
      features: ['秒级隐患识别', '故障预警提前7-14天', '可用率提升1.8%', '检修费用下降15%'],
      process: ['传感器快速部署', '云端频谱/包络分析', '异常推送', '处置与复盘'],
      image: require('@/assets/8.jpg')
    },
    {
      id: 3,
      name: '工艺智能优化',
      shortDesc: '工艺知识图谱驱动的制造智能化',
      icon: 'fas fa-industry',
      description: '基于IndustMind工业大模型，结合工艺知识图谱实现工艺参数优化、工艺智能生成、加工质量预测、零件智能选型与产线进度预测，保障订单准时交付。',
      features: ['工艺参数优化', '工艺智能生成', '加工质量预测', '产线进度预测'],
      process: ['数据采集', '知识图谱构建', '工艺生成/优化', '质量预测与监控'],
      image: require('@/assets/2.png')
    },
    {
      id: 4,
      name: '数字双碳管理',
      shortDesc: '建筑/企业/园区双碳一体化',
      icon: 'fas fa-leaf',
      description: '面向建筑双碳管理、企业双碳管理与政府产业园区双碳管理，构建完善的产品生态与架构，落地多场景双碳监测、核算与优化。',
      features: ['碳排放监测', '碳核算与报告', '园区/建筑场景', '降碳策略优化'],
      process: ['数据接入', '碳核算', '可视化监测', '降碳优化'],
      image: require('@/assets/7.png')
    }
  ]
}

const mutations = {}

const actions = {}

const getters = {
  getAllServices: (state) => state.services,
  getServiceById: (state) => (id) => {
    return state.services.find(service => service.id === parseInt(id))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
